import { render, staticRenderFns } from "./RevisorProgramacio.vue?vue&type=template&id=77732783&scoped=true&"
import script from "./RevisorProgramacio.vue?vue&type=script&lang=js&"
export * from "./RevisorProgramacio.vue?vue&type=script&lang=js&"
import style0 from "./RevisorProgramacio.vue?vue&type=style&index=0&id=77732783&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77732783",
  null
  
)

export default component.exports